import slugify from "slugify";
import Database from "better-sqlite3";
import { d as private_env } from "./shared-server.js";
import { n as nanoid } from "./util.js";
import nodemailer from "nodemailer";
import { Blob } from "node:buffer";
const ADMIN_NAME$2 = private_env.ADMIN_NAME;
const DEFAULT_BIO = {
  avatar: "/images/person-placeholder.jpg",
  name: ADMIN_NAME$2,
  bio: "<p>Welcome to my PostOwl website!</p>"
};
const SMTP_SERVER = private_env.SMTP_SERVER;
const SMTP_PORT = private_env.SMTP_PORT;
const SMTP_USERNAME = private_env.SMTP_USERNAME;
const SMTP_PASSWORD = private_env.SMTP_PASSWORD;
const ADMIN_NAME$1 = private_env.ADMIN_NAME;
const ADMIN_EMAIL = private_env.ADMIN_EMAIL;
async function sendMail(to, subject, message) {
  try {
    let transporter = nodemailer.createTransport({
      host: SMTP_SERVER,
      port: SMTP_PORT,
      secure: parseInt(SMTP_PORT) === 465 ? true : false,
      // SSL is reserved for SMPT_PORT 465
      auth: {
        user: SMTP_USERNAME,
        pass: SMTP_PASSWORD
      }
    });
    let info = await transporter.sendMail({
      from: `"${ADMIN_NAME$1}" <${ADMIN_EMAIL}>`,
      to,
      subject,
      // text: 'Plain text version'
      html: message
    });
    console.log("Message sent: %s", info.messageId);
  } catch (err) {
    console.error(err);
  }
}
const DB_PATH = private_env.DB_PATH;
const ADMIN_NAME = private_env.ADMIN_NAME;
const ADMIN_PASSWORD = private_env.ADMIN_PASSWORD;
let db = new Database(DB_PATH, {
  // verbose: console.log
});
db.pragma("journal_mode = WAL");
db.pragma("case_sensitive_like = false");
async function createPost(title, content, teaser, teaser_image, recipients, is_public, { currentUser, origin }) {
  if (!currentUser)
    throw new Error("Not authorized");
  if (!title)
    throw new Error("Title mandatory");
  return db.transaction(() => {
    let slug = slugify(title, {
      lower: true,
      strict: true
    });
    const postExists = db.prepare("SELECT * FROM posts WHERE slug = ?").get(slug);
    if (postExists) {
      slug = slug + "-" + nanoid();
    }
    const post = db.prepare(
      "INSERT INTO posts (slug, title, content, teaser, teaser_image, is_public, created_at) values(?, ?, ?, ?, ?, ?, ?) RETURNING slug, post_id, created_at"
    ).get(
      slug,
      title,
      content,
      teaser,
      teaser_image ? JSON.stringify(teaser_image) : null,
      is_public ? 1 : 0,
      (/* @__PURE__ */ new Date()).toISOString()
    );
    for (let i = 0; i < recipients.length; i++) {
      const recipient = recipients[i];
      let friend;
      let friend_id = recipient.friend_id;
      if (!friend_id) {
        friend = db.prepare("INSERT INTO friends (email, created_at) values(?, ?) RETURNING friend_id").get(recipient.email, (/* @__PURE__ */ new Date()).toISOString());
        friend_id = friend.friend_id;
      }
      const secret = nanoid();
      db.prepare(
        "INSERT INTO recipients (post_id, friend_id, secret) values(?, ?, ?) RETURNING recipient_id"
      ).get(post.post_id, friend_id, secret);
      sendMail(
        recipient.email,
        title,
        `<p>Hi ${recipient.name?.split(" ")[0]},</p>
        <p>I'm writing to you from my website, here's the first part:</p>
        <p>${teaser}</p>
        <p><a href="${`${origin}/posts/${slug}?secret=${secret}`}">Read the full post</a>.</p>
        <p>${ADMIN_NAME.split(" ")[0]}</p>
        <p><em>(This message was sent from ${ADMIN_NAME}'s <a href="https://www.postowl.com">PostOwl</a> website.)</em></p>`
      );
    }
    return post;
  })();
}
async function updatePost(slug, title, content, teaser, teaser_image, recipients, is_public, { currentUser, origin }) {
  if (!currentUser)
    throw new Error("Not authorized");
  if (!title)
    throw new Error("Title is mandatory");
  return db.transaction(async () => {
    let new_slug;
    const { title: old_title, post_id } = db.prepare("SELECT title, post_id FROM posts WHERE slug = ?").get(slug);
    if (old_title !== title) {
      new_slug = slugify(title, {
        lower: true,
        strict: true
      });
      const new_slugExists = db.prepare("SELECT * FROM posts WHERE slug = ?").get(new_slug);
      if (new_slugExists) {
        new_slug = new_slug + "-" + nanoid();
      }
    }
    const post = db.prepare(
      "UPDATE posts SET slug = ?, title= ?, content = ?, teaser = ?, teaser_image = ?, is_public = ?, updated_at = ? WHERE slug = ? RETURNING slug, post_id, updated_at"
    ).get(
      new_slug || slug,
      title,
      content,
      teaser,
      teaser_image ? JSON.stringify(teaser_image) : null,
      is_public ? 1 : 0,
      (/* @__PURE__ */ new Date()).toISOString(),
      slug
    );
    if (new_slug) {
      db.prepare("DELETE FROM old_post_slugs WHERE slug = ?").run(new_slug);
      db.prepare("INSERT INTO old_post_slugs (slug, post_id) values(?, ?)").run(slug, post_id);
    }
    const previous_recipients = db.prepare("SELECT recipient_id FROM recipients WHERE post_id = ?").all(post.post_id).map((r) => r.recipient_id);
    const new_recipients = [];
    for (let i = 0; i < recipients.length; i++) {
      const recipient = recipients[i];
      let friend_id = recipient.friend_id;
      if (!friend_id) {
        const friend = db.prepare("INSERT INTO friends (email, created_at) values(?, ?) RETURNING friend_id").get(recipient.email, (/* @__PURE__ */ new Date()).toISOString());
        friend_id = friend.friend_id;
      }
      const recipient_exists = db.prepare("SELECT recipient_id FROM recipients WHERE post_id = ? AND friend_id = ?").get(post.post_id, friend_id);
      if (!recipient_exists) {
        const secret = nanoid();
        const { recipient_id } = db.prepare(
          "INSERT INTO recipients (post_id, friend_id, secret) values(?, ?, ?) RETURNING recipient_id"
        ).get(post.post_id, friend_id, secret);
        sendMail(
          recipient.email,
          title,
          `<p>Hi ${recipient.name?.split(" ")[0]},</p>
          <p>I'm writing to you from my website, here's the first part:</p>
          <p>${teaser}</p>
          <p><a href="${`${origin}/posts/${slug}?secret=${secret}`}">Read the full post</a>.</p>
          <p>${ADMIN_NAME.split(" ")[0]}</p>
          <p><em>(This message was sent from ${ADMIN_NAME}'s <a href="https://www.postowl.com">PostOwl</a> website.)</em></p>`
        );
        new_recipients.push(recipient_id);
      } else {
        new_recipients.push(recipient_exists.recipient_id);
      }
    }
    for (let i = 0; i < previous_recipients.length; i++) {
      const r = previous_recipients[i];
      if (new_recipients.indexOf(r) === -1) {
        db.prepare("DELETE FROM recipients WHERE recipient_id = ?").run(r);
      }
    }
    const current_recipients = db.prepare(
      "SELECT f.name, f.email, f.friend_id, secret FROM recipients r INNER JOIN friends f ON (r.friend_id=f.friend_id) WHERE r.post_id = ?"
    ).all(post.post_id);
    return {
      ...post,
      // slug, post_id, updated_at
      recipients: current_recipients
    };
  })();
}
async function authenticate(password, sessionTimeout) {
  const expires = __getDateTimeMinutesAfter(sessionTimeout);
  if (password === ADMIN_PASSWORD) {
    const sessionId = nanoid();
    db.prepare("DELETE FROM sessions WHERE expires < ?").run((/* @__PURE__ */ new Date()).toISOString());
    db.prepare("INSERT INTO sessions (session_id, expires) values(?, ?) returning session_id").run(
      sessionId,
      expires
    );
    return { sessionId };
  } else {
    throw "Authentication failed.";
  }
}
async function destroySession(sessionId) {
  db.prepare("DELETE FROM sessions WHERE session_id = ?").run(sessionId);
  return true;
}
async function getPosts(currentUser, searchQuery, searchFilter) {
  let posts;
  let filterClause = "";
  if (searchFilter === "public") {
    filterClause = " AND is_public IS TRUE";
  } else if (searchFilter === "private") {
    filterClause = " AND is_public IS FALSE";
  }
  if (currentUser) {
    posts = db.prepare(
      `SELECT * FROM posts WHERE (title LIKE ? OR content LIKE ?)${filterClause} ORDER BY created_at DESC`
    ).all(`%${searchQuery}%`, `%${searchQuery}%`);
  } else {
    posts = db.prepare(
      "SELECT * FROM posts WHERE is_public IS TRUE AND (title LIKE ? OR content LIKE ?) ORDER BY created_at DESC"
    ).all(`%${searchQuery}%`, `%${searchQuery}%`);
  }
  for (let i = 0; i < posts.length; i++) {
    const post = posts[i];
    post.recipients = db.prepare(
      `
      SELECT
      coalesce(f.name, f.email) AS name
      FROM recipients r
      INNER JOIN friends f ON (r.friend_id=f.friend_id)
      WHERE r.post_id = ?
      `
    ).all(post.post_id);
  }
  return posts;
}
async function getFriends(currentUser) {
  if (!currentUser)
    throw new Error("Not authorized");
  return db.prepare("SELECT * FROM friends ORDER BY created_at DESC").all();
}
async function getFriend(friend_id, currentUser) {
  if (!currentUser)
    throw new Error("Not authorized");
  const friend = db.prepare("SELECT * FROM friends WHERE friend_id = ?").get(friend_id);
  return { ...friend };
}
async function createFriend(name, email, currentUser) {
  if (!currentUser)
    throw new Error("Not authorized");
  const friend = db.prepare(
    "INSERT INTO friends (name, email, created_at) VALUES (?, ?, ?) RETURNING friend_id, created_at"
  ).get(name, email || null, (/* @__PURE__ */ new Date()).toISOString());
  return friend;
}
async function updateFriend(friend_id, name, email, currentUser) {
  if (!currentUser)
    throw new Error("Not authorized");
  return db.prepare(
    "UPDATE friends SET name= ?, email = ?, updated_at = ? WHERE friend_id = ? RETURNING friend_id, updated_at"
  ).get(name, email, (/* @__PURE__ */ new Date()).toISOString(), friend_id);
}
async function deleteFriend(friend_id, currentUser) {
  if (!currentUser)
    throw new Error("Not authorized");
  return db.transaction(() => {
    db.prepare("DELETE FROM recipients WHERE friend_id = ?").run(friend_id);
    db.prepare("DELETE FROM friends WHERE friend_id = ?").run(friend_id);
    return true;
  })();
}
async function getPostBySlug(slug, secret = void 0, currentUser) {
  return db.transaction(() => {
    let post;
    post = db.prepare("SELECT * FROM posts WHERE slug = ?").get(slug);
    if (!post) {
      const { post_id } = db.prepare("SELECT post_id FROM old_post_slugs WHERE slug = ?").get(slug);
      post = db.prepare("SELECT * FROM posts WHERE post_id = ?").get(post_id);
    }
    let hasAccess = false;
    if (currentUser || post.is_public) {
      hasAccess = true;
    }
    if (secret) {
      const { recipient_id } = db.prepare("SELECT recipient_id FROM recipients WHERE post_id = ? AND secret = ?").get(post.post_id, secret);
      if (recipient_id) {
        hasAccess = true;
        db.prepare("UPDATE recipients SET has_seen = TRUE WHERE recipient_id = ?").run(
          recipient_id
        );
      }
    }
    if (!hasAccess)
      throw new Error("Not authorized");
    let recipients = [];
    if (currentUser) {
      recipients = db.prepare(
        "SELECT f.name, f.email, f.friend_id, secret, has_seen FROM recipients r INNER JOIN friends f ON (r.friend_id=f.friend_id) WHERE r.post_id = ?"
      ).all(post.post_id);
    }
    return { ...post, recipients };
  })();
}
async function deletePost(slug, currentUser) {
  if (!currentUser)
    throw new Error("Not authorized");
  return db.transaction(() => {
    const { post_id } = db.prepare("SELECT post_id FROM posts WHERE slug = ?").get(slug);
    db.prepare("DELETE FROM old_post_slugs WHERE post_id = ?").run(post_id);
    db.prepare("DELETE FROM recipients WHERE post_id = ?").run(post_id);
    db.prepare("DELETE FROM posts WHERE slug = ?").run(slug);
    return true;
  })();
}
async function getCurrentUser(session_id) {
  const stmt = db.prepare(
    "SELECT session_id, expires FROM sessions WHERE session_id = ? AND expires > ?"
  );
  const session = stmt.get(session_id, (/* @__PURE__ */ new Date()).toISOString());
  const bio = await getBio();
  if (session) {
    return { name: bio.name || "Admin" };
  } else {
    return null;
  }
}
async function searchFriends(q, currentUser) {
  if (currentUser) {
    const result = db.prepare(
      "SELECT * FROM friends WHERE email LIKE ? OR name LIKE ? ORDER BY created_at DESC LIMIT 6"
    ).all(`%${q}%`, `%${q}%`);
    return result;
  }
}
async function createOrUpdatePage(page_id, page, currentUser) {
  if (!currentUser)
    throw new Error("Not authorized");
  const pageExists = db.prepare("SELECT page_id FROM pages WHERE page_id = ?").get(page_id);
  if (pageExists) {
    return db.prepare("UPDATE pages SET data = ?, updated_at = ? WHERE page_id = ? RETURNING page_id").get(JSON.stringify(page), (/* @__PURE__ */ new Date()).toISOString(), page_id);
  } else {
    return db.prepare("INSERT INTO pages (page_id, data, updated_at) values(?, ?, ?) RETURNING page_id").get(page_id, JSON.stringify(page), (/* @__PURE__ */ new Date()).toISOString());
  }
}
async function getPage(page_id) {
  const page = db.prepare("SELECT data FROM pages WHERE page_id = ?").get(page_id);
  if (page?.data) {
    return JSON.parse(page.data);
  } else {
    return null;
  }
}
async function getBio() {
  const bio = await getPage("bio");
  return bio || DEFAULT_BIO;
}
async function getCounts() {
  const counts = db.prepare(
    `
    SELECT
    (SELECT COUNT(*) FROM friends) AS friend_count,
    (SELECT COUNT(*) FROM posts) AS post_count;
  `
  ).get();
  return counts;
}
async function createOrUpdateCounter(counter_id) {
  return db.transaction(() => {
    const counter_exists = db.prepare("SELECT counter_id FROM counters WHERE counter_id = ?").get(counter_id);
    if (counter_exists) {
      return db.prepare("UPDATE counters SET count = count + 1 WHERE counter_id = ? RETURNING count").get(counter_id);
    } else {
      return db.prepare("INSERT INTO counters (counter_id, count) values(?, 1) RETURNING count").get(counter_id);
    }
  })();
}
async function storeAsset(asset_id, file) {
  const arrayBuffer = await file.arrayBuffer();
  const buffer = Buffer.from(arrayBuffer);
  const sql = `
  INSERT into assets (asset_id, mime_type, updated_at, size, data) VALUES (?, ?, ?, ?, ?)
  ON CONFLICT (asset_id) DO
  UPDATE
     SET mime_type = excluded.mime_type,
         updated_at = excluded.updated_at,
         size = excluded.size,
         data = excluded.data
  WHERE asset_id = excluded.asset_id
  `;
  const stmnt = db.prepare(sql);
  stmnt.run(asset_id, file.type, (/* @__PURE__ */ new Date()).toISOString(), file.size, buffer);
}
function getAsset(asset_id) {
  const sql = `
  SELECT
    asset_id,
    mime_type,
    updated_at,
    size,
    data
  FROM assets
  WHERE asset_id = ?
  `;
  const stmnt = db.prepare(sql);
  const row = stmnt.get(asset_id);
  return {
    filename: row.asset_id.split("/").slice(-1),
    mimeType: row.mime_type,
    lastModified: row.updated_at,
    size: row.size,
    data: new Blob([row.data], { type: row.mime_type })
  };
}
async function getSitemap() {
  return db.transaction(() => {
    const posts = db.prepare(
      "SELECT slug, created_at, COALESCE(created_at, updated_at) AS modified_at FROM posts ORDER BY created_at DESC"
    ).all();
    const mostRecentPost = posts[0];
    const sitemap = [];
    posts.forEach((a) => {
      sitemap.push({
        url: `/posts/${a.slug}`,
        lastmod: new Date(a.modified_at).toISOString()
      });
    });
    return sitemap.concat([
      { url: "/", lastmod: new Date(mostRecentPost?.modified_at).toISOString() }
    ]);
  })();
}
async function getRSSFeedData() {
  const bio = await getBio();
  const posts = db.prepare("SELECT * FROM posts WHERE is_public IS TRUE ORDER BY created_at DESC LIMIT 20").all();
  const result = {
    ...bio,
    posts
  };
  return result;
}
function __getDateTimeMinutesAfter(minutes) {
  return new Date((/* @__PURE__ */ new Date()).getTime() + minutes * 6e4).toISOString();
}
export {
  createFriend as a,
  createPost as b,
  createOrUpdateCounter as c,
  deleteFriend as d,
  deletePost as e,
  createOrUpdatePage as f,
  updatePost as g,
  storeAsset as h,
  getAsset as i,
  getRSSFeedData as j,
  getSitemap as k,
  getPosts as l,
  getFriends as m,
  getFriend as n,
  authenticate as o,
  destroySession as p,
  getPostBySlug as q,
  getCurrentUser as r,
  searchFriends as s,
  getBio as t,
  updateFriend as u,
  getCounts as v
};
